import RxTypography from "./RxTypography";

export default RxTypography;
